<template>
<div>

    <m-named-pair 
        text="Phone Number"
        :value="prettyPrintEndpoint(value.endpoint)"
        hide_empty
    />

     <div 
        style="margin-bottom: 15px"
        v-if="value.consent_summary != null"
    >
        <b>Consent</b><br>
        <div>Conversational: {{value.consent_summary.conversational}}</div>
        <div>Informational: {{value.consent_summary.informational}}</div>
        <div>Promotional: {{value.consent_summary.promotional}}</div>
        <div
            style="margin-top: 10px"
            v-if="value.has_consent_summary"
        >
            <a
                v-on:click="onClickViewConsentDetails"
            >
                View consent details...
            </a>
        </div>
    </div>

    <div 
        v-if="crm_customer_tags.length > 0"
        style="margin-bottom: 15px"
    >
        <b>Tags</b><br>
        <div
            v-for="(item, key) in crm_customer_tags"
            :key="key"
        >
            {{item}}
        </div>
    </div>

    <m-named-pair 
        text="Line Type"
        :value="prettyLineType()"
        hide_empty
    />

    <m-named-pair 
        text="Carrier"
        :value="value.validation_network_name"
        hide_empty
    />

    <m-named-pair 
        text="Carrier Code"
        :value="value.validation_mobile_network_code"
        hide_empty
    />

    <m-named-pair 
        text="Country"
        :value="value.validation_country_code"
        hide_empty
    />

    <m-named-pair 
        text="Mobile Country Code"
        :value="value.validation_mobile_country_code"
        hide_empty
    />

    <m-named-pair 
        text="Last Verified"
        :value="prettyPrintValidationTime()"
        hide_empty
    />

    <b>Label Changes</b>

    <v-data-table
        v-if="value != null"
        :headers="headers"
        :items="value.label_changes"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        style="margin-top: 15px"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>
    
    </v-data-table>


</div>
</template>

<script>
const E164 = require('@/js/E164.js');
const Time = require('@/js/time.js'); 

export default {

    props: {
        value: {
            type: Object,
            default: function() { return {}; },
        },
    },

    data() {
        return {
            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Change', value: 'change_description'},
                { text: 'Origin', value: 'origin_description'},
            ],
        }
    },

    methods: {
        prettyPrintEndpoint(endpoint) {
            if ( endpoint == null ) return null;
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        prettyPrintValidationTime()
        {
            if ( this.value == null || this.value.validation_time == null )
                return null;

            return Time.getMMDDYYYY(this.value.validation_time);
        },

        prettyLineType()
        {
            if ( this.value == null || this.value.validation_line_type == null )
                return null;

            let type = this.value.validation_line_type;

            if ( type == 'domestic-mobile' ) return 'Mobile';
            if ( type == 'domestic-landline' ) return 'Landline';
            if ( type == 'domestic-invalid' ) return 'Not in service';
            if ( type == 'domestic-unknown' ) return null;
            if ( type == 'international-unknown' ) return 'International';

            return null;
        },

        onClickViewConsentDetails()
        {
            this.$router.dialog_guard = null; // in case we are in a dialog...

            this.$router.push({
                'name': 'view-consent-details',
                'params' : {
                    'organization_id': this.value.consent_summary.organization_id,
                    'endpoint': this.value.consent_summary.endpoint,
                }
            });
        },
    },

    computed: {
        crm_customer_tags() {
            let ret = this.$rc.getDeep(this.value,"crm_customer_tags");
            if ( ret == null ) return [];
            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>